class ProductInquiryContainer extends Component {
    constructor(el) {
        super(el);

        this.updateElementReferences();
        this.addEventListeners();
    }

    updateElementReferences() {
        this.productVariant = this.$el.querySelector('[data-product-variant]');
        this.productTitle = this.$el.querySelector('[data-product-title]');
        this.inquryFormFrame = this.$el.querySelector('[data-inquiry-form-frame]');
        this.asideImage = this.$el.querySelector('[data-inquiry-form-aside-image]');
        this.loadFormElement();
        this.inquirySource = this.$el.dataset.inquirySource ?? '';
    }

    /**
     * @param {number} variantId
     */
    async changeVariantInForm(variantId) {
        this.formProductElement.value = variantId;

        const productVariantResponse = await fetch('/eshop/poptavka-produktu/varianta-produktu?id=' + variantId);
        const productVariantData = await productVariantResponse.json();
        this.productVariant.outerHTML = productVariantData['html'];
        this.asideImage.innerHTML = productVariantData['asideImage'];
        this.productTitle.textContent = productVariantData['title'];

        this.updateElementReferences();
    };

    /**
     * @param {Event} event
     */
    async sendInquiry(event) {
        event.preventDefault();

        await this.inquiryForm(this.formProductElement.value);
        EventBus.getInstance().dispatchEvent('inquiryFormSent');
    }

    /**
     * @param {number} variantId
     */
    async inquiryForm(variantId) {
        this.updateElementReferences()
        const params = new URLSearchParams({
            id: variantId,
            inquirySource: this.inquirySource,
        })

        EventBus.getInstance().dispatchEvent('showGlobalSpinner');
        if (this.formElement) {
            const formData = new FormData(this.formElement);
            const inquiryFormResponse = await fetch('/eshop/poptavka-produktu?' + params.toString(), {
                "method": "POST",
                "body": formData,
            });
            const inquiryFormData = await inquiryFormResponse.json();
            this.inquryFormFrame.innerHTML = inquiryFormData['html'];
        } else {
            const inquiryFormResponse = await fetch('/eshop/poptavka-produktu?' + params.toString());
            const inquiryFormData = await inquiryFormResponse.json();
            this.inquryFormFrame.innerHTML = inquiryFormData['html'];
        }

        EventBus.getInstance().dispatchEvent('hideGlobalSpinner');

        this.updateElementReferences();
        this.addFormEventListeners();
    }

    async changeProductId(productId) {
        this.loadFormElement(); // Před změnou ověříme, zda je formulář k dispozici a podle toho určíme, co za operaci se má provést
        if (this.formElement) {
            await this.changeVariantInForm(productId);
        } else {
            await this.inquiryForm(productId);
            EventBus.getInstance().dispatchEvent('inquiryFormReloaded');
        }
    }

    loadFormElement() {
        this.formElement = this.$el.querySelector('form');
        if (this.formElement) {
            this.formProductElement = this.formElement.querySelector('[data-form-product-element]');
        }
    }

    addEventListeners() {
        EventBus.getInstance().addEventListener("productVariantChanged", async (event) => {
            await this.changeProductId(event.detail.id);
        });
        EventBus.getInstance().addEventListener("productInquiryProductIdChanged", async (event) => {
            await this.changeProductId(event.detail.id);
        });
        this.addFormEventListeners();
    }

    addFormEventListeners() {
        if (!this.formElement) {
            return;
        }

        this.formElement.addEventListener('submit', this.sendInquiry.bind(this));
    }

}